/**
 * 28 spec カラートークン (Notion design language)
 *
 * 一次情報: hub/log/28_20260429_notion_meetings_uiux_research/03_ui_implementation_spec.md §1.1
 * 移植元: nasu-patient-app-front/src/shared/styles/colorTokens.ts (yakureki-front も同一値)
 *
 * 運用規則:
 *  - 純黒 #000 / 純白 on body は使わない (本文は fg.default = #373530)
 *  - accent.primary 以外の彩度の高い色は「状態を示す」ときのみ
 *  - 罫線 (border.default) は最後の手段。原則は bg.subtle/muted で領域分割
 */
export const colorTokens = {
  bg: {
    default: '#FFFFFF',
    subtle: '#F7F7F5',
    muted: '#F1F1EF',
    emphasis: '#EDEDEC',
  },
  border: {
    default: '#E9E9E7',
    subtle: 'rgba(55,53,47,0.09)',
    faint: 'rgba(55,53,47,0.06)',
  },
  overlay: {
    soft: 'rgba(55,53,47,0.03)',
    hover: 'rgba(55,53,47,0.04)',
    selected: 'rgba(55,53,47,0.06)',
    active: 'rgba(55,53,47,0.08)',
    placeholderIcon: 'rgba(55,53,47,0.2)',
    /** モーダルの暗幕。医療向けに弱める (design-book color.md・MUI 既定 0.5 は使わない) */
    backdrop: 'rgba(0,0,0,0.3)',
  },
  fg: {
    default: '#373530',
    muted: '#787774',
    faint: '#A6A299',
    disabled: '#C7C5BF',
  },

  accent: {
    primary: '#2383E2',
    primaryHover: '#1A6BB8',
    primaryFg: '#FFFFFF',
    ring: '#2383E2',
  },

  state: {
    infoBg: '#E9F3F7',
    infoFg: '#487CA5',
    warnBg: '#FAF3DD',
    warnFg: '#C29343',
    warnIcon: '#CB912F',
    dangerBg: '#FAECEC',
    dangerFg: '#C4554D',
    dangerIcon: '#D44C47',
    successBg: '#DDEDDF',
    successFg: '#448361',
  },

  focus: {
    ringShadow: '0 0 0 4px rgba(35,131,226,0.25)',
    ringNeutral: '0 0 0 2px rgba(55,53,47,0.20)',
  },

  shadow: {
    cardSubtle: '0 1px 2px rgba(15,15,15,0.04)',
    popover:
      '0 0 0 1px rgba(15,15,15,0.05), 0 3px 6px rgba(15,15,15,0.10), 0 9px 24px rgba(15,15,15,0.20)',
    modal: '0 0 0 1px rgba(15,15,15,0.05), 0 12px 36px rgba(15,15,15,0.30)',
  },
} as const

export type ColorTokens = typeof colorTokens
